<template>
<div class="card-section-container"
    :style="gap ? `gap: ${gap}px` : 'gap: 16px'"
    :class="class"

>
    <div
        class="card-title-container"
        :style="needsBorder ? 'border-bottom: 1px solid rgba(0,0,0,0.1);' : ''"
        v-if="showTitlePart"
    >
        <div class=title-container v-if="showTitlePart">
            <h5 v-if="title">{{ title }}</h5>
            <span v-if="description">{{ description }}</span>
        </div>
        <slot name="customBtn" />
    </div>
    <div class="card-content-container">
        <slot/>
    </div>
</div>
</template>
<script>
export default {
    computed: {
        showTitlePart() {
            return this.title || this.description;
        },
    },
    props: {
        title: {
            type: String,
        },
        description: {
            type: String,
        },
        class: {
            type: String,
        },
        needsBorder: {
            type: Boolean,
        },
        gap: {
            type: Number
        }
    },
}
</script>
<style lang="scss" scoped>

$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$CertiBlue : #278AEC;

.card-section-container {
    width: 100%;
    display: flex;
    background-color: white;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
    padding: 0;
    .card-title-container {
        width: 100%;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        gap: 10px;
        .title-container {
            display: flex;
            gap: 8px;
            align-items: center;
            h5 {
                display: flex;
                align-items: center;
                font-size: 17px;
                color: $Gray-90;
                font-family: 'SuitBold';
                margin-bottom: 0;
            }
            span {
                color: $Gray-60;
                display: flex;
                align-items: center;
                margin-bottom: 0;
                font-size: 14px;
            }
        }
    }
    .card-content-container {
        width: 100%;
    }
}

@media (max-width: 767px) {
    .card-section-container {
        .card-title-container {
            width: 100%;
            flex-direction: column;
            height: fit-content;
            align-items: flex-start;
            .title-container {
                height: 52px;
            }
        }
    }
}

</style>

